import { colors } from '../../../constants/styleConstants';
import { breakpoints } from '../breakpoints';

export const dateRangeFilterStyle = {
  // Date Filter Section
  dateFilter: {
    height: 35,
  },
  dateFilterComponent: {
    '& .DayPickerInput-Overlay ': {
      zIndex: 10,
    },

    '& .DayPicker': {
      margin: 'auto',
      width: '100%',
    },

    '& .DayPicker-Day': {
      padding: '0.6em',
    },
  },

  // AddDays Filter Section
  dayInput: {
    position: 'absolute !important',
    clip: 'rect(0, 0, 0, 0)',
    height: 1,
    width: 1,
    border: 0,
    overflow: 'hidden',

    '&:checked + label': {
      borderColor: colors.darkBlue,
      backgroundColor: colors.blue1,
      color: colors.darkBlue,
    },
  },
  addDaysGroup: {
    display: 'flex',
    flexFlow: 'row wrap',
    marginTop: 0,
    flexGrow: 1.5,
  },
  addDaysAction: {
    width: 60,
    height: 34,
    margin: '10px 8px 0 0',
    padding: '10px 2px',
    borderRadius: 8,
    border: `1px solid ${colors.fieldsBorderGray}`,
    backgroundColor: colors.white,
    fontSize: 12,
    color: colors.darkText,
    flexGrow: 1,

    '&:hover': {
      borderColor: colors.darkBlue,
      backgroundColor: colors.blue1,
      color: colors.darkBlue,
    },

    '&:active': {
      borderColor: colors.darkBlue,
      backgroundColor: colors.blue1,
      color: colors.darkBlue,
    },

    '&:focus': {
      borderColor: colors.darkBlue,
      backgroundColor: colors.blue1,
      color: colors.darkBlue,
    },

    '&:last-child': {
      marginRight: 0,
    },
  },
  todayLabel: {
    marginRight: '0',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    padding: '7px 6px',
    textAlign: 'center',
    width: 'fit-content',
    minWidth: 88,
  },
  tomorrowLabel: {
    marginLeft: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 8,
    padding: '7px 6px',
    textAlign: 'center',
    width: 'fit-content',
    minWidth: 88,
  },

  // breakpoints
  [breakpoints.small]: {
    dateFilterComponent: {
      '& .DayPicker': {
        fontSize: 14,
        margin: 'auto',
        width: '100%',
      },
      '& .DayPicker-Day': {
        padding: 10,
      },
    },
    dateFilter: {
      width: 'calc(100% - 24px)',
    },
    addDaysGroup: {
      margin: 0,
      flexFlow: 'row wrap',
    },
    addDaysAction: {
      margin: '5px 5px 5px 0',

      '&:last-child': {
        marginRight: 0,
      },
    },
    todayLabel: {
      marginRight: 0,
    },
  },
  [breakpoints.medium]: {
    addDaysGroup: {
      width: 'calc(50% - 12px)',
    },
  },
};
